module.exports = __webpack_public_path__ + "static/media/040-world.1976b882.svg";